import { FunctionComponent } from 'react';
import { Box } from '@mui/material';
import { useLocale } from '../contexts/LocaleProvider';
import { IntlProvider } from 'react-intl';
import { PrefilteredResourceLibraryItemsProvider } from '../graphql/pimcore/modules/resourceLibrary/contexts/PrefilteredResourceLibraryItemsProvider';
import TechnicalResources from './automotivePage/TechnicalResources';
import ReusableTabs from './common/ReusableTabs';
import * as styles from './productPage/tableComponents/ProductPage_style';
import BreadCrumbs from './common/BreadCrumbs';
import { useSalesAndResourcesSensorAcademyContent } from '../graphql/pimcore/modules/siteContent/hooks/useSalesAndResourcesSensorAcademyContent';
import DebouncedLoader from './common/DebouncedLoader';

const SensorAcademyPage: FunctionComponent = () => {
    const { locale, messages } = useLocale();
    const { loading, error, contentTree } = useSalesAndResourcesSensorAcademyContent();
    const navigationPath = '/Home/SalesAndResources/SensorAcademy';

    if (error && !loading) {
        return <div className="mid-width">Error: {error.message}</div>;
    }

    return (
        <DebouncedLoader loading={loading} delay={1000} size={40} centered={true}>
            <IntlProvider locale={locale} key={locale} defaultLocale="en" messages={messages}>
                <PrefilteredResourceLibraryItemsProvider
                    initialFilters={{
                        navigationScopePaths: [navigationPath],
                    }}
                >
                    <Box
                        width="100%"
                        component="main"
                        sx={{
                            padding: 0,
                            flexGrow: 0,
                            p: 0,
                        }}
                    >
                        <ReusableTabs
                            bannerImage={contentTree.pageTitleBackgroundImage.imageUrl}
                            bannerTitle={contentTree.pageTitle.content}
                            bannerDescription={contentTree.pageSubtitle.content}
                            tabLabels={[]}
                            tabKeys={[]}
                            tabContents={[
                                <TechnicalResources
                                    key="technical-resources"
                                    backgroundColor={'white'}
                                />,
                            ]}
                            bannerFontStyle={styles.bannerFont}
                            subBannerFontStyle={styles.bannerFont2}
                            pageName={'sensorAcademy'}
                            showTabs={false}
                            breadcrumbs={<BreadCrumbs navigationPath={navigationPath} />}
                        />
                    </Box>
                </PrefilteredResourceLibraryItemsProvider>
            </IntlProvider>
        </DebouncedLoader>
    );
};
export default SensorAcademyPage;
